import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Separate instance for customer-account calls (uses its own token, kept apart from admin)
export const customerApi = axios.create({ baseURL: API });
customerApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("drift_customer_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Normalize stored file paths: relative "/api/files/..." -> absolute; external URLs pass through
export const fileUrl = (u) => (u && typeof u === "string" && u.startsWith("/api")) ? `${BACKEND_URL}${u}` : u;

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("drift_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
